import React, {useEffect, useRef, useState} from "react";
import styles from './CarruselShopper.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

export function CarruselShopper({paginas, numberPage, setPaginaSelected}) {
    const refCarrusel = useRef(null);
    const [showIcon, setShowIcon] = useState(false);

    const moveCarruselLeft = () => {
        setShowIcon(true)
        refCarrusel.current.scrollLeft += 300
    }

    const moveCarruselRight = () => {
        refCarrusel.current.scrollLeft -= 300
    }

    useEffect(() => {
        if (numberPage && refCarrusel && refCarrusel.current) {
            const element = document.getElementById('page-' + numberPage);
            if (element) {
                const scrollTop = refCarrusel.current.scrollLeft;
                const elementOffsetTop = element.offsetLeft;
                refCarrusel.current.scrollLeft = elementOffsetTop - scrollTop;
            }
        }
    }, [numberPage, refCarrusel, paginas])

    return (
        <div className={`position-relative`}>
            <div className={`${styles.containerSiguienteButton}`} onClick={moveCarruselLeft}>
                <FontAwesomeIcon className={`${styles.button}`} icon={solid('chevron-right')}/>
            </div>
            <div className={`${styles.containerAnteriorButton}`}
                 style={!showIcon ? {display: 'none'} : {display: 'block'}} onClick={moveCarruselRight}>
                <FontAwesomeIcon className={`${styles.button}`} icon={solid('chevron-left')}/>
            </div>
            <div ref={refCarrusel} className={`d-flex overflow-auto ${styles.pages}`}>
                {paginas && paginas.map((img) => {
                    const imgData = img.attributes || img;
                    const imagenUrl = imgData.imagen?.data?.attributes?.url || imgData.imagen?.url;
                    const imagenCaption = imgData.imagen?.data?.attributes?.caption || imgData.imagen?.caption || '';
                    if (!imagenUrl) return null;
                    return (<div key={img.id || imgData.numeroPagina} id={`page-${imgData.numeroPagina}`} className={`mr-2`} onClick={() => setPaginaSelected(img)}>
                        <img
                            className={styles.imagen}
                            src={imagenUrl}
                            alt={imagenCaption}/>
                    </div>)
                })}
            </div>
        </div>)
}

export default CarruselShopper;
